module.exports = __webpack_public_path__ + "assets/img/solar-panels-7-small.0562e712.jpg";